// mapMockData.js - 处理地图相关的模拟数据
import shipData from '@/mockdata/data.json'
import mockLayerData from '@/mockdata/mock-layer-data.json'

/**
 * 加载船舶模拟数据
 * @returns {Array} 船舶数据数组
 */
export function loadShipData() {
  console.log('加载船舶数据')
  if (!shipData || !Array.isArray(shipData)) {
    console.error('船舶数据无效:', shipData)
    return []
  }
  
  return shipData
}

/**
 * 计算地图中心点（取所有有位置的船舶的平均位置）
 * @param {Array} ships 船舶数据数组 
 * @returns {Array} 中心点坐标 [lat, lng]
 */
export function calculateMapCenter(ships) {
  const shipsWithPos = Array.isArray(ships) ? ships.filter(ship => ship && ship.pos) : []
  
  if (shipsWithPos.length > 0) {
    const sumLat = shipsWithPos.reduce((sum, ship) => sum + ship.pos.latitude, 0)
    const sumLng = shipsWithPos.reduce((sum, ship) => sum + ship.pos.longitude, 0)
    const center = [sumLat / shipsWithPos.length, sumLng / shipsWithPos.length]
    console.log('计算地图中心点:', center)
    return center
  }
  
  // 返回默认中心点
  return [23.1125, 113.32861]
}

/**
 * 加载图层模拟数据
 * @returns {Object} 包含shipTracks和warningAreas数据的对象
 */
export function loadMockLayerData() {
  console.log('加载模拟图层数据')
  
  if (!mockLayerData) {
    console.error('模拟图层数据加载失败')
    return {
      shipTracks: [],
      warningAreas: []
    }
  }
  
  // 加载船舶航迹数据
  const shipTracks = mockLayerData.shipTracks || []
  console.log('加载船舶航迹数据:', shipTracks.length)
  
  // 加载警戒区域数据
  const warningAreas = mockLayerData.warningAreas || []
  console.log('加载警戒区域数据:', warningAreas.length)
  
  return {
    shipTracks,
    warningAreas
  }
} 